import type { ReactNode } from 'react'
import type { DayListGroup } from './day-list'
import { DayListRowButton } from './day-list-row'

/**
 * The day list's sections: a small heading over a list of rows, each row a
 * button into the sheet of the thing it names. The day sheet and the "Reviews
 * to leave" sheet both list their rows this way.
 */
export function DayListGroups({ groups }: { groups: DayListGroup[] }): ReactNode {
  return groups.map(group => (
    <section
      key={group.id}
      aria-label={group.heading}
      data-testid={`day-list-${group.id}`}
      className="space-y-1.5"
    >
      <h3 className="text-xs font-semibold uppercase tracking-wide text-textMuted">
        {group.heading}
      </h3>
      {group.note && <p className="text-xs text-textMuted">{group.note}</p>}
      <ul className="space-y-1.5">
        {group.rows.map(row => (
          <li key={row.key}>
            <DayListRowButton row={row} />
          </li>
        ))}
      </ul>
    </section>
  ))
}
